// dependencies
import { Map } from "immutable";
import React from "react";

// components
import Button from "../../../../../../components/Button";
import { Divider } from "../../../../../../components/Divider";
import SelectInput, { Result } from "../../../../../../components/Inputs/SelectInput";
import Typography from "../../../../../../components/Text";

// utils
import forceInt from "../../../../../../utils/ForceInt";

// config
import config from "../../config";
// styles
import css from "./DigestTiming.module.scss";

type DigestTimingProps = {
	className?: string;
	label: string;
	weeklyDigest: Map<string, string>;
	setWeeklyDigest: (weeklyDigest: Map<string, string>) => void;
	saveWeeklyDigestTimingSettings: () => void;
};

const DigestTiming = (props: DigestTimingProps) => {
	const { className = "", label, weeklyDigest, setWeeklyDigest, saveWeeklyDigestTimingSettings } = props;

	return (
		<div className={`${css.digestTiming} ${className}`}>
			<div className={css.label}>
				<Typography size="paragraph-2" weight="semi-bold" color="neutral-9">
					{label}
				</Typography>
			</div>

			<div className={css.inputsRow}>
				<div className={`${css.inputContainer}`}>
					<SelectInput
						value={weeklyDigest.get("day")}
						results={config.dayOfTheWeekOptions as unknown as Result[]}
						onChange={(value) => {
							setWeeklyDigest(weeklyDigest.set("day", value));
						}}
					/>
				</div>

				<div className={`${css.inputContainer}`}>
					<SelectInput
						value={weeklyDigest.get("hour")?.toString() ?? ""}
						results={config.digestTimeOptions as unknown as Result[]}
						onChange={(value) => {
							setWeeklyDigest(weeklyDigest.set("hour", forceInt(value)));
						}}
					/>
				</div>
				<Button
					onClick={saveWeeklyDigestTimingSettings}
					className={css.saveButton}
					color="green"
					disabled={saveWeeklyDigestTimingSettings === null}
				>
					Save
				</Button>
			</div>
			<Divider />
		</div>
	);
};

export default DigestTiming;
